import React from "react"
import { StaticImage } from "gatsby-plugin-image"

import Close from "../../assets/svg/iconClose.svg"
import ExclamationIcon from "../../assets/svg/exclamationIcon.svg"

import styles from "./styles.module.styl"

const ActionNotification = props => (
	<div
		className={`
            ${styles.actionNotification}
            ${props.isError ? styles.__isError : ""}
            ${props.className || ""}
          `}
	>
		{/* Иконка слева */}
		{props.isError ? (
			<ExclamationIcon className={styles.actionNotification__icon} />
		) : (
			<StaticImage
				className={styles.actionNotification__icon}
				src="../../assets/images/smile.png"
			/>
		)}

		{/* Текст нотификации */}
		<span
			className={styles.actionNotification__text}
			dangerouslySetInnerHTML={{ __html: props.text }}
		/>

		{/* Кнопка закрытия */}
		<Close
			className={styles.actionNotification__close}
			onClick={props.closeHandler}
		/>
	</div>
)
export default ActionNotification
